import React from 'react';
import PropTypes from 'prop-types';

class MapInfo extends React.Component {

  render() {
    const tableStyle = {
      maxWidth: 400
    };
    const cellStyle = {
      verticalAlign: 'top',
      minWidth: 100
    };
    return (
      <table style={tableStyle}>
        <tbody>
        <tr>
          <th style={cellStyle}>Customer</th>
          <td style={cellStyle}>{this.props.feature.properties.customer}</td>
        </tr>
        {
          this.props.feature.properties.isLocation ? (
            <tr>
              <th style={cellStyle}>Location</th>
              <td style={cellStyle}>{this.props.feature.properties.location}</td>
            </tr>
          ) : null
        }
        <tr>
          <th style={cellStyle}>Status</th>
          <td style={cellStyle}>{this.props.feature.properties.status}</td>
        </tr>
        <tr>
          <th style={cellStyle}>Message</th>
          <td style={cellStyle}>{this.props.feature.properties.message || ''}</td>
        </tr>
        <tr>
          <th style={cellStyle}>Is a location</th>
          <td style={cellStyle}>{this.props.feature.properties.isLocation ? 'Yes' : 'No'}</td>
        </tr>
        <tr>
          <th style={cellStyle}>Identifier</th>
          <td style={cellStyle}>{this.props.feature.properties.uuid}</td>
        </tr>
        </tbody>
      </table>
    )
  }


}

MapInfo.propTypes = {
  feature: PropTypes.shape({
    geometry: PropTypes.shape({
      coordinates: PropTypes.arrayOf(
        (value) => {
          return value.length >= 2 && value.every(coordinatePart => typeof item === 'number')
        }
      ).isRequired
    }).isRequired,
    properties: PropTypes.shape({
      status: PropTypes.string,
      message: PropTypes.string,
      isLocation: PropTypes.bool,
      uuid: PropTypes.string,
      customer: PropTypes.string,
      location: PropTypes.string
    }).isRequired,
    type: PropTypes.oneOf(['Feature']).isRequired
  }).isRequired
};

export default MapInfo;


// WEBPACK FOOTER //
// ./src/app/map/info.js